import { Box, Button } from "@mui/material";
import React from "react";
import { orderStatusFormatted } from "src/constant";
import useCountOrderTabs from "src/hooks/orders/useCountOrderTabs";
import useQueryParams from "src/hooks/useQueryParams";

export default function OrderChildTabExchange({ warehouseId }) {
  const [option, setOption] = useQueryParams();
  const { data: counts } = useCountOrderTabs({
    warehouse: warehouseId,
    tab: option?.tab,
  });

  const childTab = [
    {
      id: orderStatusFormatted.WaitToExport,
      name: `Chuẩn bị hàng (${counts?.data["WaitToExport"]})`,
    },
    {
      id: orderStatusFormatted.ReadyToPick,
      name: `Chờ lấy hàng (${counts?.data["ReadyToPick"]})`,
    },
    {
      id: orderStatusFormatted.Delivering,
      name: `Đang giao (${counts?.data["Delivering"]})`,
    },
    // { id: orderStatusFormatted.Delivered, name: `Đã giao ${counts?.data["Delivered"]}` },
    {
      id: orderStatusFormatted.Returning,
      name: `Đang trả hàng (${counts?.data["Returning"]})`,
    },
    {
      id: orderStatusFormatted.ReturnedWaitToCheck,
      name: `Kiểm tra hoàn hàng (${counts?.data["ReturnedWaitToCheck"]})`,
    },
    { id: orderStatusFormatted.Canceled, name: `Đơn hủy (${counts?.data["Canceled"]})` },
    { id: orderStatusFormatted.Returned, name: `Trả hàng (${counts?.data["Returned"]})` },
    {
      id: orderStatusFormatted.DeliveredFailed,
      name: `Giao không TC (${counts?.data["DeliveredFailed"]})`,
    },
  ];

  const handleChildTab = (value) => {
    setOption({ ...option, childTab: value });
  };
  return (
    <Box mb="12px">
      {childTab.map((v) => {
        return (
          <Button
            key={v.id}
            sx={{
              borderRadius: "100px",
              p: "4px 8px",

              background: [
                orderStatusFormatted[v.id],
                // orderStatusFormatted.ReturnRefund,
              ]?.includes(option?.childTab)
                ? "var(--grey)"
                : "transparent",
            }}
            onClick={() => handleChildTab(v.id)}
          >
            {v.name}
          </Button>
        );
      })}
    </Box>
  );
}
